/* eslint-disable react/prop-types */
import cx from 'classnames';
import React from 'react';

const Row = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>(
  ({ className, ...rest }, ref) => <div ref={ref} className={cx('row', className)} {...rest} />
);

export default Row;
